/**
 * Google Analytics Service
 * Fetches GA4 data via Supabase Edge Function
 */

export const gaAnalyticsService = {
  async getAnalytics() {
    const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
    if (!supabaseUrl) {
      throw new Error('Supabase URL not configured');
    }

    const response = await fetch(`${supabaseUrl}/functions/v1/ga-analytics`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${import.meta.env?.VITE_SUPABASE_ANON_KEY}`
      },
      body: JSON.stringify({})
    });

    if (!response?.ok) {
      const errorData = await response?.json().catch(() => ({}));
      throw new Error(errorData?.error || 'Failed to fetch analytics');
    }

    return response.json();
  }
};
